'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BAOCart = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _pushCartActions = require('../../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _functional = require('../../utils/functional');

var _tracking = require('../../utils/tracking');

var _products = require('../../services/products');

var _errors = require('./errors');

var _utils = require('./utils');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var tracking = {
  ACTION_ADD_TO_CART: 'Add To Cart'
};

var BAOCart = exports.BAOCart = function () {
  function BAOCart() {
    (0, _classCallCheck3.default)(this, BAOCart);

    this.setupAddToCartForms(this.addToCartFormClass);
  }

  (0, _createClass3.default)(BAOCart, [{
    key: 'addItemsToCart',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
        var items = _ref2.items,
            discountPercentage = _ref2.discountPercentage;
        var eventAddToCart;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!window.theme.isBHPreview) {
                  _context.next = 6;
                  break;
                }

                eventAddToCart = new Event('add_to_cart_mix_and_match');
                _context.next = 4;
                return (0, _tracking.setMixAndMatchDataLayerItems)({ items: items, discountPercentage: discountPercentage });

              case 4:
                eventAddToCart.payload = _context.sent;

                // eventAddToCart.payload.context = {
                //   category: 'Mix and Match',
                // }
                document.dispatchEvent(eventAddToCart);

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return this.store.dispatch(pushCartActions.addItemsToCart({ items: items }));

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](6);

                this.store.dispatch(pushCartActions.addError((0, _errors.UNKNOWN_ERROR)()));

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 11]]);
      }));

      function addItemsToCart(_x) {
        return _ref.apply(this, arguments);
      }

      return addItemsToCart;
    }()
  }, {
    key: 'addItemsToPushCart',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref4) {
        var items = _ref4.items;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                window.drawers.activeDrawerKey = 'cart';

                _context2.next = 3;
                return this.addItemsToCart({ items: items });

              case 3:

                this.store.dispatch(pushCartActions.setItemBeingAddedId(null));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addItemsToPushCart(_x2) {
        return _ref3.apply(this, arguments);
      }

      return addItemsToPushCart;
    }()
  }, {
    key: 'addItemToCart',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            id = _ref6.id,
            handle = _ref6.handle,
            _ref6$properties = _ref6.properties,
            properties = _ref6$properties === undefined ? {} : _ref6$properties,
            _ref6$quantity = _ref6.quantity,
            quantity = _ref6$quantity === undefined ? 1 : _ref6$quantity,
            _ref6$price = _ref6.price,
            price = _ref6$price === undefined ? 0 : _ref6$price;

        var item, data, numberOfVariants, _ref7, addedMoreThanExists, allowedQuantity, alreadyInCart, productName, newItem, _newItem;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(id === undefined && handle === undefined)) {
                  _context3.next = 2;
                  break;
                }

                throw new Error('id or handle is required');

              case 2:
                item = { id: id, properties: properties, quantity: quantity, price: price };

                if (!(id === undefined && handle !== undefined)) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 6;
                return (0, _products.getProductByHandle)(handle);

              case 6:
                data = _context3.sent;
                numberOfVariants = data.variants.length;

                if (!(numberOfVariants > 1)) {
                  _context3.next = 10;
                  break;
                }

                throw new Error('The handle property can only be used if there is only 1 variant. ' + data.title + ' has ' + numberOfVariants + ' variants');

              case 10:

                item = (0, _assign2.default)({}, item, {
                  id: data.variants[0].id
                });

              case 11:
                _context3.prev = 11;
                _context3.next = 14;
                return this.store.dispatch(pushCartActions.addItemToCart(item));

              case 14:
                _context3.next = 40;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](11);
                _context3.next = 20;
                return BAOCart.handleAddItemToCartError(_context3.t0);

              case 20:
                _ref7 = _context3.sent;
                addedMoreThanExists = _ref7.addedMoreThanExists;
                allowedQuantity = _ref7.allowedQuantity;
                alreadyInCart = _ref7.alreadyInCart;
                productName = _ref7.productName;

                if (!alreadyInCart) {
                  _context3.next = 29;
                  break;
                }

                this.store.dispatch(pushCartActions.addError((0, _errors.ALREADY_HAVE_ALL_STOCK_ERROR)(productName)));
                _context3.next = 40;
                break;

              case 29:
                if (!addedMoreThanExists) {
                  _context3.next = 36;
                  break;
                }

                newItem = (0, _assign2.default)({}, item, {
                  quantity: allowedQuantity
                });
                _context3.next = 33;
                return this.store.dispatch(pushCartActions.addItemToCart(newItem));

              case 33:

                this.store.dispatch(pushCartActions.addError((0, _errors.NOT_ENOUGH_IN_STOCK_ERROR)(productName)));
                _context3.next = 40;
                break;

              case 36:
                _newItem = (0, _assign2.default)({}, item, {
                  quantity: allowedQuantity
                });
                _context3.next = 39;
                return this.store.dispatch(pushCartActions.addItemToCart(_newItem));

              case 39:

                this.store.dispatch(pushCartActions.addError((0, _errors.ADD_TOO_MANY_ERROR)(item.quantity, allowedQuantity, productName)));

              case 40:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[11, 16]]);
      }));

      function addItemToCart() {
        return _ref5.apply(this, arguments);
      }

      return addItemToCart;
    }()
  }, {
    key: 'addItemToPushCart',
    value: function () {
      var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            id = _ref9.id,
            handle = _ref9.handle,
            _ref9$properties = _ref9.properties,
            properties = _ref9$properties === undefined ? {} : _ref9$properties,
            _ref9$quantity = _ref9.quantity,
            quantity = _ref9$quantity === undefined ? 1 : _ref9$quantity,
            _ref9$price = _ref9.price,
            price = _ref9$price === undefined ? 0 : _ref9$price,
            eventCategory = _ref9.eventCategory,
            eventSource = _ref9.eventSource,
            eventTitle = _ref9.eventTitle;

        var product, variant, eventAddToCart;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.store.dispatch(pushCartActions.setItemBeingAddedId(id));

                window.drawers.activeDrawerKey = 'cart';

                _context4.next = 4;
                return this.addItemToCart({ id: id, handle: handle, properties: properties, quantity: quantity });

              case 4:

                this.store.dispatch(pushCartActions.setItemBeingAddedId(null));

                /* NOTE: This is a very temporary quick-fix for BH tracking during internal testing.
                Should be cleaned up before full launch. */

                if (!window.theme.isBHPreview) {
                  _context4.next = 15;
                  break;
                }

                _context4.next = 8;
                return (0, _products.getProductByHandle)(handle);

              case 8:
                product = _context4.sent;
                variant = product.variants.find(function (variant) {
                  return variant.id === id;
                });
                eventAddToCart = new Event('add_to_cart');

                eventAddToCart.payload = (0, _tracking.setDataLayerItem)({ product: product, variant: variant, quantity: quantity });
                // eventAddToCart.payload.context = {
                //   category: eventCategory,
                //   source: eventSource,
                //   title: eventTitle,
                // }
                document.dispatchEvent(eventAddToCart);
                _context4.next = 16;
                break;

              case 15:
                this.trackAddToCart({
                  id: id,
                  handle: handle,
                  quantity: quantity,
                  price: price,
                  eventCategory: eventCategory
                });

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addItemToPushCart() {
        return _ref8.apply(this, arguments);
      }

      return addItemToPushCart;
    }()
  }, {
    key: 'setupAddToCartForms',
    value: function setupAddToCartForms(selector, context) {
      var _this = this;

      var addToCartForms = (0, _functional.getElements)(selector, { context: context });

      for (var i = 0; i < addToCartForms.length; i++) {
        addToCartForms[i].addEventListener('click', function (e) {
          return e.stopPropagation();
        });

        addToCartForms[i].addEventListener('submit', function () {
          var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(e) {
            var form, formData, id, handle, quantity, price, properties;
            return _regenerator2.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    e.preventDefault();

                    form = e.target;
                    formData = new FormData(form);
                    id = Number(formData.get('id'));
                    handle = formData.get('handle');
                    quantity = Number(formData.get('quantity'));
                    price = Number(formData.get('price'));
                    properties = BAOCart.buildProperties(formData);
                    _context5.next = 10;
                    return _this.addItemToPushCart({
                      id: id,
                      handle: handle,
                      properties: properties,
                      quantity: quantity,
                      price: price,
                      eventCategory: form.dataset.eventCategory,
                      eventSource: form.dataset.eventSource,
                      eventTitle: form.dataset.eventTitle
                    });

                  case 10:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this);
          }));

          return function (_x5) {
            return _ref10.apply(this, arguments);
          };
        }());
      }
    }
  }, {
    key: 'trackAddToCart',
    value: function () {
      var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(_ref12) {
        var id = _ref12.id,
            handle = _ref12.handle,
            quantity = _ref12.quantity,
            price = _ref12.price,
            eventCategory = _ref12.eventCategory;
        var cart, product, variant;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return shopifyCart.getState();

              case 3:
                cart = _context6.sent;
                _context6.next = 6;
                return (0, _products.getProductByHandle)(handle);

              case 6:
                product = _context6.sent;
                variant = product.variants.find(function (variant) {
                  return variant.id === id;
                });

                if (eventCategory) {
                  (0, _tracking.trackGtag)({
                    eventCategory: eventCategory,
                    eventAction: tracking.ACTION_ADD_TO_CART,
                    eventLabel: handle,
                    eventValue: quantity
                  });
                }

                (0, _tracking.trackSnaptr)('track', 'ADD_CART', {
                  currency: Shopify.currency.active,
                  price: price / 100,
                  item_ids: [(0, _stringify2.default)(id)]
                });

                (0, _tracking.trackTtq)('AddToCart', {
                  content_id: id,
                  content_type: 'product',
                  quantity: quantity,
                  value: cart.total_price / 100,
                  price: price / 100,
                  currency: Shopify.currency.active
                });

                (0, _tracking.trackPintrk)('track', 'AddToCart', {
                  value: cart.total_price / 100,
                  order_quantity: cart.item_count,
                  currency: Shopify.currency.active,
                  line_items: [{
                    product_name: product.title,
                    product_id: product.id,
                    product_category: product.product_type,
                    product_variant_id: variant.id,
                    product_price: parseFloat(variant.price),
                    product_quantity: quantity,
                    product_brand: product.vendor
                  }]
                });

                (0, _tracking.trackObApi)('track', 'Add2Cart');
                _context6.next = 17;
                break;

              case 15:
                _context6.prev = 15;
                _context6.t0 = _context6['catch'](0);

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 15]]);
      }));

      function trackAddToCart(_x6) {
        return _ref11.apply(this, arguments);
      }

      return trackAddToCart;
    }()
  }, {
    key: 'addToCartFormClass',
    get: function get() {
      return '.js-AddToCart';
    }
  }, {
    key: 'store',
    get: function get() {
      return window.store;
    }
  }], [{
    key: 'buildProperties',
    value: function buildProperties(formData) {
      var propertyKeyValues = [].concat((0, _toConsumableArray3.default)(formData.entries())).filter(function (_ref13) {
        var _ref14 = (0, _slicedToArray3.default)(_ref13, 2),
            key = _ref14[0],
            value = _ref14[1];

        return key.includes('properties[') && value !== '';
      });

      function propertyReducer(properties, _ref15) {
        var _ref16 = (0, _slicedToArray3.default)(_ref15, 2),
            key = _ref16[0],
            value = _ref16[1];

        var strippedKey = key.replace('properties[', '').slice(0, -1);

        return (0, _assign2.default)({}, properties, (0, _defineProperty3.default)({}, strippedKey, value));
      }

      return propertyKeyValues.reduce(propertyReducer, {});
    }
  }, {
    key: 'handleAddItemToCartError',
    value: function () {
      var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(error) {
        var errJson, status, description, alreadyInCart, addedMoreThanExists, allowedQuantity;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return error.json();

              case 2:
                errJson = _context7.sent;
                status = errJson.status, description = errJson.description;
                alreadyInCart = description.slice(0, 4) === 'All ';
                addedMoreThanExists = description.slice(0, 18) === 'You can\'t add more';

                // We've tried adding to many of a quantity to the cart
                // We'll try and grab the amount we can add and add that

                if (!(status === 422)) {
                  _context7.next = 9;
                  break;
                }

                allowedQuantity = 1;
                return _context7.abrupt('return', {
                  addedMoreThanExists: addedMoreThanExists,
                  allowedQuantity: allowedQuantity,
                  alreadyInCart: alreadyInCart,
                  productName: (0, _utils.findProductName)(description, alreadyInCart)
                });

              case 9:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function handleAddItemToCartError(_x7) {
        return _ref17.apply(this, arguments);
      }

      return handleAddItemToCartError;
    }()
  }]);
  return BAOCart;
}();